



















































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame, CFrame} from './GadgetFrame.vue';
import Charts from '@/components/charts';
import ListChart from '@/components/charts/ListChart.vue';
import SelectBox, {IOption} from '@/components/util/SelectBox.vue';

const EDIT = 'EDIT';

// 通信
import API from '@/api/common';
// const api = new API();
import * as models from '@/class/models/views/graph';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'SampleGadgetBase',
  components: { GadgetFrame, SelectBox, ListChart },
  props: {
    title: String,
    materials: Object,
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    w: Number,
    h: Number,
    dashBoard: {
      type: Boolean,
      default: false,
    },
    plasticCase: {
      type: Boolean,
      default: false,
    },
    resized: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mode: EDIT,
      charts: Charts,
      selectGraphValue: '',
      dataObj: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [40, 39, 10, 40, 39, 80, 40],
          },
        ],
      },
      // dataObj: {},
      optionsObj: {},
      baseOptionsObj: {
        responsive: !this.dashBoard,
        maintainAspectRatio: !this.dashBoard,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{display: false, value: {}, ticks: {}}],
          xAxes: [{display: false, value: {}, ticks: {}}],
        },
      },
      ct1Options: [{text: '田中', value: 1}] as IOption[],
      ct1Value: '',
      ct1Back: '[]',
      ct1ValueBack: 0,
      ct1Flag: false,
      ct2Options: [{text: '2020', value: 2020}] as IOption[],
      ct2Back: '[]',
      ct2Flag: false,
      ct2: '',
      ct2ValueBack: '',
      year: moment.fncGetThisYear(),
      month: moment.fncGetLastMonthStr(),
      date: moment.fncGetLastMonthDateStr(),
      widthX: GRAPH_HW,
      heightX: GRAPH_HW,
      error: false,
      loading: false,
    };
  },
  watch: {
    /*
    async year(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '年'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    async month(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '月'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    async date(newInput, oldInput) {
      if (newInput !== oldInput) {
        const material = this.materials.target.filter((v: models.ICommonObj) => (v.key === '日'));
        material[0].value = newInput;
        this.ct2ValueBack = newInput;
        // await this.getBasicGraphData();
      }
    },
    */
    w() {
      this.setSize();
    },
    h() {
      this.setSize();
    },
  },
  async mounted() {
    this.selectGraphValue = this.gadgetData.data.graph[0].key;
    // サンプルデータ設定処理
    this.setSize();

    // console.log(this.gadgetData.data);

    const measureDate = NOC.MATERIAL.V3.getTargetDate(this.gadgetData.data.materials);
    if (measureDate) {
      if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH.id) {
        this.sample1();
      } else if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_DATE.id) {
        const setDate = NOC.MATERIAL.V3.getTargetSetData(this.gadgetData.data.materials);
        if (setDate) {
          this.sample3();
        } else {
          this.sample2();
        }
      } else if (measureDate.id === NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR.id) {
        this.sample4();
      }
    }
    // await this.getBasicGraphData();
  },
  methods: {
    setSize() {
      // console.log(this.w);
      this.heightX = GRAPH_HW * this.h;
      this.widthX = GRAPH_HW * this.w;
    },
    sample1() {
      this.ct2 = '月';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR;
      color = color.concat(color);

      labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
      datasets =  [
          {
            label: '勤務時間',
            backgroundColor: color,
            data: [180, 170, 130, 80, 60, 10, 0],
          },
      ];
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample2() {
      this.ct2 = '日';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR;
      color = color.concat(color);

      labels = ['高橋', '鈴木', '佐藤', '山田', '矢口', '佐々木', '田中'];
      datasets =  [
          {
            label: '勤務時間',
            backgroundColor: color,
            data: [8, 4, 7, 6.5, 8, 2, 0],
          },
      ];
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample3() {
      this.ct1Flag = true;
      this.ct2 = '日';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + '分';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + '分';
            },
          };
          break;
      }

      // let color = NOC.GRAPH.OPTIONS.BCOLOR;
      // color = color.concat(color);

      const dateArray = [...Array(24)].map((v, i) => (i + '時'));

      labels = dateArray;
      datasets =  [
          {
            label: '勤務時間',
            backgroundColor: this.hex2rgba(NOC.GRAPH.OPTIONS.BCOLOR[0], 0.5),
            data: dateArray.map((v, i) => {
              if (10 <= i && i <= 19 && i !== 13) {
                return Math.floor(Math.random() * Math.floor(5)) * 15;
              } else {
                return 0;
              }
            }),
          },
      ];
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    sample4() {
      this.ct1Flag = true;
      this.ct2 = '年';
      this.ct2Flag = true;
      let datasets = [] as any[];
      let labels = [] as any[];
      const tmpOptionObj = JSON.parse(JSON.stringify(this.baseOptionsObj));
      switch (this.selectGraphValue) {
        case NOC.CHARTS.BAR:
         case NOC.CHARTS.LINE:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.yAxes[0].ticks = {
            callback(label: any, index: any, ylabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          tmpOptionObj.scales.yAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].display = true;
          tmpOptionObj.scales.xAxes[0].ticks = {
            callback(label: any, index: any, xlabels: any[]) {
              return (label).toString() + 'h';
            },
          };
          break;
      }

      let color = NOC.GRAPH.OPTIONS.BCOLOR;
      color = color.concat(color);
      color = color.concat(color);
      const dateArray = [...Array(12)].map((v, i) => ( (i + 1) + '月'));

      labels = dateArray;
      datasets =  [
          {
            label: '',
            backgroundColor: color,
            data: dateArray.map((v, i) => {
              return Math.floor(Math.random() * Math.floor(30)) * 8;
            }),
          },
      ];
      this.dataObj = {
        labels,
        datasets,
      };
      this.optionsObj = tmpOptionObj;
      this.setSize();
    },
    hex2rgba(hex: string, alpha = 1) {
      // ロングバージョンの場合（例：#FF0000）
      let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      let c = null;
      if (r) {
          c = r.slice(1, 4).map((x) => (parseInt(x, 16)));
      }
      // ショートバージョンの場合（例：#F00）
      r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
      if (r) {
          c = r.slice(1, 4).map((x) => (0x11 * parseInt(x, 16)));
      }
      // 該当しない場合は、nullを返す.
      if (!c) {
          return null;
      }
      return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${alpha})`;
    },
  },
});
